export default __webpack_public_path__ + "static/media/paper.1cbd018e.png";